<template>
    <div v-if="active" class="card">
        <div class="card-body">
            <PageHeader :title="title" variant="small" class="mb-4" />
            <div v-html="notice"></div>
            <ActionList :actions="screenData.actions" @continue-sfl="continueSFL" @delete-sfl="deleteSFL" @skip-sfl="skipSFL"></ActionList>
        </div>
    </div>
</template>

<script>
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "SaveForLater",

        components: {
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                title: "",
                notice: "",
                links: {}
            }
        },

        methods: {
            show: function(data) {
                this.title = data.data[0].title;
                this.notice = data.data[0].message;
                this.links = data.links;
                this.storeNextAction({
                    next: data.links.delete
                });
                this.active = true;
            },

            hide: function() {
                this.active = false;
            },

            continueSFL: function() {
                this.$emitter.emit('start-loading','continue-sfl');
                this.$axios.get(this.links.onContinue.href + "?t=" + new Date().getTime()).then(function(response) {
                    window.location.href = this.links.next.href;
                }.bind(this));
            },

            deleteSFL: function() {
                this.$emitter.emit('start-loading','delete-sfl');
                this.continue();
            },

            skipSFL: function() {
                this.$emitter.emit('start-loading','skip-sfl');
                this.goToPortfolio();
            }
        }
    }
</script>